import { StatusBar } from 'expo-status-bar';
import React, { useState, useEffect } from 'react';
import { ActivityIndicator, View} from 'react-native';
import { withAuthenticator } from 'aws-amplify-react-native'
import AsyncStorage from '@react-native-async-storage/async-storage'
import Amplify from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import {CreateUpload} from './src/graphql/mutations';
import config from './src/aws-exports';
import Login from './src/screens/Login';
import CreateAccount from './src/screens/CreateAccount';
import ConfirmCreateAccount from './src/screens/ConfirmCreateAccount';
import Home from './src/screens/Home';
import SelectFile from './src/screens/SelectFile';
import UploadFile from './src/screens/UploadFile';
import EStyleSheet from 'react-native-extended-stylesheet';
import ResetPassword from './src/screens/ResetPassword';

EStyleSheet.build({ // always call EStyleSheet.build() even if you don't use global variables!
  $forwardButtonBackgroundColor: '#1bb3f9',
  $reverseButtonBackgroundColor: 'red',
  $buttonTextColor: 'white',
  $textColor: 'black',
  $inputBackgroundPlaceholderTextColor: '#6e6869'
});
Amplify.configure(config)
window.LOG_LEVEL = 'VERBOSE';



const AuthenticationStack = createStackNavigator();
const AppStack = createStackNavigator();


const AuthenticationNavigator = props => {
  return (
    <AuthenticationStack.Navigator screenOptions={{ headerMode: 'screen' }}>
      <AuthenticationStack.Screen name="Login">
        {screenProps => (
          <Login {...screenProps} updateAuthState={props.updateAuthState} />
        )}
     
      </AuthenticationStack.Screen>
      <AuthenticationStack.Screen name="ResetPassword" component={ResetPassword} />
      <AuthenticationStack.Screen name="CreateAccount" component={CreateAccount} />
      <AuthenticationStack.Screen
        name="ConfirmCreateAccount"
        component={ConfirmCreateAccount}
      />
    </AuthenticationStack.Navigator>
  );
};
const AppNavigator = props => {
  return (
    <AppStack.Navigator>
      <AppStack.Screen name="Home">
        {screenProps => (
          <Home {...screenProps} updateAuthState={props.updateAuthState} />
        )}
      </AppStack.Screen>
      <AppStack.Screen name="SelectFile" 
      options={{ title: 'File Selection' }}
      component={SelectFile}/>
      <AppStack.Screen name="UploadFile" 
      options={{ title: 'Upload a Report' }}
      component={UploadFile}/>
    </AppStack.Navigator>
  );
};

const Initializing = () => {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <ActivityIndicator size="large" color="tomato" />
      </View>
    );
  };



function App() {
  
  const [isUserLoggedIn, setUserLoggedIn] = useState('initializing');
  
  useEffect(() => {
    checkAuthState();
  }, []);
  async function checkAuthState() {
    try {
      await Auth.currentAuthenticatedUser();
      console.log(' User is signed in');
      
      setUserLoggedIn('loggedIn');
    } catch (err) {
      console.log('User is not signed in');
      setUserLoggedIn('loggedOut');
    }
  }
  function updateAuthState(isUserLoggedIn) {
    setUserLoggedIn(isUserLoggedIn);
  }

  return (
    <NavigationContainer>
      {isUserLoggedIn === 'initializing' && <Initializing />}
      {isUserLoggedIn === 'loggedIn' && (
        <AppNavigator updateAuthState={updateAuthState} />
      )}
      {isUserLoggedIn === 'loggedOut' && (
        <AuthenticationNavigator updateAuthState={updateAuthState} />
      )}
    </NavigationContainer>
  );
}
    export default App;
